function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Virtuoso } from 'react-virtuoso';
import { Loader } from '../../Loader';
import { SelectMenuContext } from '../context';
import { ProgressiveIndicator } from '@dtsl/icons/dist/icons/react';
const findIndex = function () {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let selectedValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return data.findIndex(e => e?.value === selectedValues[0]?.value && e?.label === selectedValues[0]?.label && e?.key === selectedValues[0]?.key) || 0;
};
const VirtualizedList = _ref => {
  let {
    data,
    itemContent,
    isSubFolder = false,
    defaultHeight,
    header: Header,
    scrollToSelectedValue = {
      align: 'start'
    }
  } = _ref;
  const {
    virtualizationProps = {},
    selectedValues,
    virtuosoRef
  } = React.useContext(SelectMenuContext);
  const index = useMemo(() => scrollToSelectedValue ? findIndex(data, selectedValues) : 0, [scrollToSelectedValue, data, selectedValues]);
  const isOptionSelected = !!scrollToSelectedValue && index >= 0 && selectedValues?.length > 0 && selectedValues[0]?.value !== '';
  const {
    align = 'start'
  } = scrollToSelectedValue;
  const {
    loadMoreData = () => {},
    listContainerHeight,
    subFolderListContainterHeight,
    overscan = 0,
    isInfiniteLoading = false,
    ...restProps
  } = virtualizationProps;
  const finalHeight = isSubFolder ? subFolderListContainterHeight ?? defaultHeight : listContainerHeight ?? defaultHeight;
  return /*#__PURE__*/React.createElement(Virtuoso, _extends({
    style: {
      height: finalHeight
    },
    overscan: overscan,
    components: {
      Footer: isInfiniteLoading ? InfiniteLoader : null,
      Header
    },
    endReached: loadMoreData,
    data: data,
    itemContent: itemContent
  }, restProps, {
    ref: virtuosoRef,
    initialTopMostItemIndex: isOptionSelected ? {
      index: index,
      align: align,
      behavior: 'auto'
    } : 0
  }));
};
VirtualizedList.propTypes = {
  data: PropTypes.array.isRequired,
  itemContent: PropTypes.func.isRequired,
  isSubFolder: PropTypes.bool,
  defaultHeight: PropTypes.number,
  header: PropTypes.func,
  scrollToSelectedValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.object])
};
const InfiniteLoader = () => {
  const indicator = /*#__PURE__*/React.createElement(ProgressiveIndicator, null);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      width: '100%',
      height: '2rem'
    }
  }, /*#__PURE__*/React.createElement(Loader, {
    className: "",
    indicator: indicator,
    isAbsolute: true
  }));
};
export default VirtualizedList;